import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";

const PublicLayout = () => {
  return (
    <>
      <Header />
      <main>
        <Outlet /> {/* This is where the nested page content will render */}
      </main>
      <Footer />
    </>
  );
};

export default PublicLayout;